define('BackorderSummary.EntryPoint', [
  'BackorderSummary.View',
  'Utils'
], function (
  BackorderSummaryView,
  Utils
) {
  'use strict';

  return {
    mountToApp: function mountToApp(container) {
      var pageType = container.getComponent('PageType');
      var myAccountMenu = container.getComponent('MyAccountMenu');

      if (!pageType || !myAccountMenu) {
        return;
      }

      myAccountMenu.addGroup({
        id: 'backorderSummary',
        name: Utils.translate('Backorder Summary'),
        url: 'backorder-summary',
        index: 50
      });

      pageType.registerPageType({
        name: 'BackorderSummary',
        routes: ['backorder-summary'],
        view: BackorderSummaryView,
        options: {
          container: container
        }
      });
    }
  };
});
